import en from "./en";
import ja from "./ja";

export default {
  en,
  ja,
};
